export default __webpack_public_path__ + "static/media/15_the_king.059d5f22.png";